import { XStack, YStack, Circle, ScrollView, SimpleText } from '@my/ui'
import { shadowGenerator } from '../../../../utils/commonStyles'
import { color, monthYearFormat } from '@my/util'

// Define milestone colors
const milestoneColors = [color.tzaGreen, color.lightRed, color.dullGrey]

// Component: Color indicator for each milestone step
const ColorMilestoneStep = ({ statusIndex }: { statusIndex: number }) => {
  return (
    <XStack paddingVertical="$2.5" style={{marginRight: 10, width: 20, height: 50}}>
      <Circle size={17} backgroundColor={milestoneColors[statusIndex % milestoneColors.length]} />
    </XStack>
  )
}

// Component: Display details for a single milestone step
const MilestoneStep = ({ milestoneName, targetDate }: MilestoneStepType) => {
  return (
    <XStack style={{alignItems: "center", gap: 20, paddingVertical: "$2", flexShrink: 1}}>
      <YStack flex={1}>
        <SimpleText fontWeight="500" fontSize={16} color={color.darkNavy}>
          {milestoneName}
        </SimpleText>
        <SimpleText color={color.lightGrey} fontSize="$2">
          {monthYearFormat(targetDate)}
        </SimpleText>
      </YStack>
    </XStack>
  )
}

// Component: Full milestone with steps and corresponding colors
const Milestone = ({ steps }: MilestoneType) => {
  return (
    <XStack 
      padding="$4" minWidth={300} width="100%" marginRight="$4" backgroundColor="#fff" gap={15} /* height={250} */
      //hoverStyle={{backgroundColor: 'rgb(240,240,240)'}}
    >
      <YStack justifyContent="space-between" flex={1}>
        {steps.map((step, index) => (
          <XStack key={index} hoverStyle={{backgroundColor: 'rgb(240,240,240)'}}>
            {/* Left column: Color indicators */}
            <ColorMilestoneStep statusIndex={index} />
            {/* Right column: Step details */}
            <MilestoneStep {...step} />
          </XStack>
        ))}
      </YStack>
    </XStack>
  )
}

// Component: List of milestones
export const MilestonesList = ({ milestones }) => {
  return (
    <ScrollView
      horizontal
      paddingBottom={20}
      paddingHorizontal={10}
      contentContainerStyle={{
        flexGrow: 1,
        width: '100%'
      }}
    >
      <XStack
        style={{ width: '100%' }}
        {...shadowGenerator(0.2)}
        bg={'#fff'}
        borderRadius="$4"
      >
        {milestones.map((milestone, index) => (
          <Milestone key={index} steps={milestone.milestones} />
        ))}
      </XStack>
    </ScrollView>
  )
}
